/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PriorityLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PriorityLabel({
  children,
  viewPath = "/DesignSystem/AutomationTask/Priority/PriorityLabel",
  onFocus,
  isShowingOptions,
  onBlur,
  optionValue,
  placeholder
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.200'
        })
let dtColorsRed200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.200'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyFontsizeMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.ms'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
  return (<React.Fragment
>
<button
  data-testid="PriorityLabel.Horizontal"
  data-view-path={viewPath}
 onClick={isShowingOptions ? onBlur : onFocus}
 style={{'--pt-1-1Ua6gj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pb-2-1Ua6gj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-3-1Ua6gj': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-4-1Ua6gj': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-5-1Ua6gj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-6-1Ua6gj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-7-1Ua6gj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-8-1Ua6gj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-9-1Ua6gj': optionValue === 'Low' ? dtColorsNeutral200 : optionValue === 'Medium' ? dtColorsBlue200 : optionValue === 'High' ? dtColorsRed200 : optionValue === 'Urgent' ? "#FCEFC7" : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={optionValue === 'Medium' ? dtColorsBlue900 : optionValue === 'High' ? "#7C5E10" : optionValue === 'Urgent' ? dtColorsRed900 : dtColorsNeutral600}
 fontSize={optionValue ? dtTypographyFontsizeMs : dtTypographyFontsizeM}
 lineHeight="13px"
 weight="medium"
 text={optionValue ? optionValue : placeholder}
/>
</button>
{children}
</React.Fragment>)
}